"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadFinancialsBar = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = require("../../atoms/Text");
const Icon_1 = require("../../atoms/Icon");
const atoms_1 = require("../../atoms");
function DownloadFinancialsBar({ name, testId, className, onClickDownload, isDownloadingFile, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('block', 'my-8', 'box-border', 'rounded-default', 'p-5', 'bg-gray-700', 'cursor-pointer', 'shadow-default', className) },
        react_1.default.createElement("div", { className: "flex justify-between items-center", onClick: onClickDownload, "data-testid": testId },
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement(Icon_1.Icon.CsvFile, null),
                react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_M, className: "ml-2", subdued: true }, name
                    ? `${name} Company Financials`
                    : 'Standardized financials and chartbook')),
            react_1.default.createElement("div", { className: "flex items-center justify-center" },
                react_1.default.createElement(Icon_1.Icon.Download, null))),
        isDownloadingFile && react_1.default.createElement(atoms_1.ProgressBar, null)));
}
exports.DownloadFinancialsBar = DownloadFinancialsBar;
//# sourceMappingURL=DownloadFinancialsBar.js.map